import React, { Component } from "react";
import Header from "../../components/PublicHeader";
import Footer from "../../scenes/LandingPage/components/Footer";

class LandingLayout extends Component {
  render() {
    return (
      <main className="homepage">
        <Header />
        {this.props.children}
        <Footer />
      </main>
    );
  }
}

export default LandingLayout;



// WEBPACK FOOTER //
// ./src/util/Layouts/LandingLayout.js